export default function Section7() {
  return (

    <section class="bg-[#F5F5F5] py-0 md:py-8">
      <div class="container mx-auto px-0 md:px-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">


        <div class="space-y-8">
          <div>
            <h2 class="text-3xl md:text-4xl font-bold mb-4 text-[#DA2128]">
              Focused on Results That Matter
            </h2>
            <p class="text-[16px] font-open text-[#373737] mt-10 lg:mt-0 mb-5">
              Our approach is simple: we don’t make empty claims — we show you results. We use advanced
              analytics to track each campaign. Then, we make real-time changes to boost performance.
              Businesses that partner with us get better leads, spend less on acquiring customers, and see
              more online engagement. That’s what sets us apart from other digital marketing agencies —
              we stay focused on your growth, not just the numbers.
            </p>
          </div>

          <div>
            <h2 class="text-3xl md:text-4xl font-bold mb-4 text-[#DA2128]">
              Let’s Grow Your Business Online
            </h2>
            <p class="text-[16px] font-open text-[#373737] mt-10 lg:mt-0 mb-5">
              If you're searching for the best digital marketing agency, Mean3 is ready to
              support your growth. We provide complete web marketing services for businesses of all sizes
              and industries. As a dedicated digital agency, we’re committed to helping you reach your goals
              with personalized, data-backed solutions. Let’s work together to take your brand to the next level. Get in touch today and find out how our digital marketing services can transform your
              online presence.
            </p>
          </div>
        </div>


        <div class="flex justify-center">
          <img src="../../../assets/m4-1.png" alt="Digital Marketing Image" class="w-full max-w-md md:max-w-full" />
        </div>

      </div>
    </section>


  );
}
